<template>
    <div class="">
  <p class="mt-2 text-xl leading-7 text-center text-gray-800 max-w">
    {{$t('review.description')}}
  </p>
 <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
      <form v-on:submit.prevent="onSubmit" v-if="!formReviewResponse">
        <div>
          <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
            {{$t('email')}}
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input v-model="form.email" id="email" type="email" name="email" class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5" />
          </div>
        </div>

        <div class="mt-4">
          <label for="name" class="block text-sm font-medium leading-5 text-gray-700">
            {{$t('name')}}
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input v-model="form.name" id="name" type="text"  name="name" class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5" />
          </div>
        </div>

        <div class="mt-4">
          <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
            {{$t('review.review')}}
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <textarea v-model="form.review" rows="5" id="review" bame="review" type="text" required class="block w-full transition duration-150 ease-in-out form-textarea sm:text-sm sm:leading-5" >

            </textarea>
          </div>
        </div>

        <div  class="relative flex items-start mt-2">
          <div class="absolute flex items-center h-5">
            <input required  v-model="form.privacy" id="pp" type="checkbox" class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox">
          </div>
          <div class="text-sm leading-5 pl-7">
            <label for="pp" class="font-medium text-gray-900" v-html="$t('newsletter.privacy',  { value: this.privacy})"></label>
          </div>
        </div>


        <div class="mt-6">
          <!--
          <span class="block w-full rounded-md shadow-sm">
            <button type="submit" class="flex justify-center w-full px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700">
              {{$t('submit')}}
            </button>
          </span>
-->
          <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
              <button :class="'bg-'+$store.state.color.primary" type="submit" class="flex items-center justify-center w-full px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out border border-transparent rounded-md focus:outline-none">
               {{$t('submit')}}
              </button>
            </div>  
        </div>
      </form>

      <div v-else>
        {{formReviewResponse}}
      </div>

 
    </div>
  </div>
    </div>
</template>

<script>
import Review from "../../../apis/Review";

export default {
  data() {
    return {
      form:{
        name: "",
        email: "",
        review: "",
        uuid: "",
        locale: "",
        privacy : 0,
      },
      formReviewResponse: "",
      privacy: ""
    }
  },
  mounted() {
    
    this.form.uuid = this.$store.state.location.uuid;
    this.form.locale = navigator.language || navigator.userLanguage;
    this.privacy = this.getPrivacyPolicyLink();

  },
  methods: {
    onSubmit: function(){
      Review.submit(this.form).then(() => {
        this.formReviewResponse = this.$t("review.thanks");
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.formErrors = error.response.data.errors;
        }
      });
    },

    getPrivacyPolicyLink(){
       if(this.$store.state.location.privacy_policy && this.$store.state.location.privacy_policy.translations){
        for(let i = 0; i < this.$store.state.location.privacy_policy.translations.length; i++){
          if(this.$store.state.location.privacy_policy.translations[i].locale == this.$store.state.locale){
            return this.$store.state.location.privacy_policy.translations[i].privacy_policy;
          }
        }
      }
    }
  }
};
</script>
